import React from "react";
import TrackedTypes from "./TrackedTypes/TrackedTypes";
import TrackedFilter from "./TrackedFilter/TrackedFilter";
import TrackedQuickActions from "./TrackedQuickActions/TrackedQuickActions";
import TrackedTable from "./TrackedTable/TrackedTable";
import usePermission from "../../../hooks/usePermission";

export default function TrackedVehicles() {
	const { view } = usePermission("LIVETRACKINGHISTORY");
	const lang = localStorage.getItem("lang") || "en";

	return (
		<div
			className={`tracked-vehicles-layout ${
				lang === "en"
					? "tracked-vehicle-layout-ltr"
					: "tracked-vehicle-layout-rtl"
			}`}
		>
			<TrackedTypes />
			<TrackedFilter />
			<div className="H-line"></div>
			{/* <TrackedQuickActions />
			<div className="H-line"></div> */}
			<TrackedTable />
		</div>
	);
}
